import * as UserActionTypes from 'actiontypes/user';
import { bootstrap } from 'actions/app';

import handleAccessCodeResult from './handleAccessCodeResult';
import setJwt from './setJwt';
import createBootstrapOptions from 'actions/user/createBootstrapOptions';

/** ----------------------------------------------------------------------------
 * TWITTER
 -----------------------------------------------------------------------------*/
export default function twitterLogin(data) {
  return (dispatch) => {
    // Setting the JWT should be the very first thing we do.
    setJwt(window, data);

    // OK, we've logged in, so let Redux know
    dispatch(twitterLoginSuccess(data));

    // If we have a character, bootstrap the app with some API requests
    if (data.hasCharacter) {
      dispatch(bootstrap(createBootstrapOptions(dispatch)));
      // Handle access code result
      dispatch(handleAccessCodeResult(data));
    }
    // Return data for caller to use
    return data;
  };
}

const twitterLoginSuccess = ({ accessCodeResult, user }) => ({
  type: UserActionTypes.TWITTER_LOGIN_SUCCESS,
  payload: { accessCodeResult, user, loggedIn: true },
});

export const twitterLoginFailure = error => ({
  type: UserActionTypes.TWITTER_LOGIN_FAILURE,
  loggedIn: false,
  loginError: true,
  status: error.response && error.response.status,
});